import React, { useState } from "react";
import BplusTermsAndConditionsLabel from "../../TermsAndConditionsLabel/TermsAndConditionsLabel";
import './TermsAndConditions.css';
import PromotionalConsentCheckbox from "../PromotionalConsentCheckbox/PromotionalConsentCheckbox";

const EasyPayPlanTermsAndConditions = (props) => {
    const { isTermsAndconditionschecked } = props;
    const [isTermsAndconditionsAgreed, setTermsAndConditionAgreed] = useState(false);
    const handleTermsAndConditions = (event) => {
        setTermsAndConditionAgreed(event.target.checked);
        isTermsAndconditionschecked(event.target.checked)
    }

    return(
        <div className="brother-plus-banner terms-and-conditions-container">
            <div className="terms-and-conditions check-box-wrapper">
                <input type="checkbox" id="brother-plus-terms-conditions" onChange={handleTermsAndConditions} checked={isTermsAndconditionsAgreed}/>
                <BplusTermsAndConditionsLabel GAText = "brotherplus-dashboard-terms-and-conditions"/>
            </div>
            <PromotionalConsentCheckbox />
        </div>
    )
};

export default EasyPayPlanTermsAndConditions;